import React from "react"
import { AppBar, Tabs, Tab } from "@material-ui/core"
import { TabPanel, useTabStyle } from "App/Component/ui"
import { instance3 } from "App/constants"
import { today } from "App/utils/helpers"

const TabHistory = React.lazy(() => import("./TabHistory"))
const TabSaldo = React.lazy(() => import("./TabSaldo"))
const TabReturSaldo = React.lazy(() => import("./TabReturSaldo"))

export const urlGet = "/kas/saldo/list"
export const urlAdd = "/kas/saldo/add"
export const urlUpdate = "/kas/saldo/update"
export const urlDelete = "/kas/saldo/delete"

export const urlGetByKunjunganId = "/kas/saldo/listByKunjunganId"
export const urlGetKunjungan =
  "/registration/registration/listregistration_billing_all"

export const RESET_STATE_SALDO = {
  id: "",
  id_kunjungan: "",
  date: today(true),
  jenis_bayar: 1,
  tipe_pembayaran_id: "",
  amount2: "",
  kas_id: null,
  kas_name: "Pilih Kas",
  tipe_kartu: "debet",
  no_kartu: "",
  no_transfer: "",
  kartu_bank: "",
}

export const getSaldoByKunjunganID = async (id) => {
  try {
    const res = await instance3.get(`${urlGetByKunjunganId}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
        total_saldo: res.data.totalSaldo,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getSaldoReturByKunjunganID = async (id) => {
  try {
    const res = await instance3.get(
      `/kas/saldo/list-retur-saldo?id_kunjungan=${id}&pages=1&limit=100`,
    )
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.body,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getSaldoHistoryByKunjunganID = async (id) => {
  try {
    const res = await instance3.get(`/kas/saldo/historyPembayaranSaldo/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const deleteSaldoByID = async (id) => {
  try {
    const api = await instance3.post(urlDelete, {
      id,
    })

    if (api.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      }
    } else {
      return {
        state: false,
        message: api.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCellsSaldo = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TGL TRANSAKSI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "amount",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
  {
    id: "namaKas",
    disablePadding: false,
    label: "KAS",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "tipePembayaran",
    disablePadding: false,
    label: "JENIS BAYAR",
    sort: false,
    align: "left",
    minWidth: "170px",
  },

  {
    id: "no_kartu",
    disablePadding: false,
    label: "NO KARTU",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_transfer",
    disablePadding: false,
    label: "NO TRANSFER",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const headCellsHistory = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id_saldo",
    disablePadding: false,
    label: "ID SALDO",
    align: "left",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "id_bayar",
    disablePadding: false,
    label: "ID BAYAR",
    align: "left",
  },
  {
    id: "id_tagihan",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
  },
  {
    id: "amount_saldo",
    disablePadding: false,
    label: "AMOUNT",
    align: "left",
  },
  {
    id: "tipe_pembayaran_id_saldo",
    disablePadding: false,
    label: "TIPE PEMBAYARAN",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  }
}

const TabMaster = ({
  rowsSaldo,
  kunjunganID,
  setNewDataSaldo,
  rowsHistory,
  value,
  setValue,
  tagihanID,
  totalSaldo,
  handleClickCetak,
}) => {
  const classes = useTabStyle()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <div className={classes.root}>
      <div className={classes.rootTab}>
        <AppBar
          position="static"
          classes={{
            root: classes.appbar,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            aria-label="Tabs Input Penjualan"
            classes={{
              root: classes.tabs,
              flexContainer: classes.fixedTab,
            }}
          >
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label="SALDO"
              {...a11yProps(0)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label="RETUR SALDO"
              {...a11yProps(2)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label="HISTORY PEMBAYARAN"
              {...a11yProps(2)}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <TabSaldo
            rows={rowsSaldo}
            kunjunganID={kunjunganID}
            setNewDataSaldo={setNewDataSaldo}
            tagihanID={tagihanID}
            handleClickCetak={handleClickCetak}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TabReturSaldo
            rowsSaldo={rowsSaldo}
            kunjunganID={kunjunganID}
            totalSaldo={totalSaldo}
            setNewDataSaldo={setNewDataSaldo}
            handleClickCetak={handleClickCetak}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <TabHistory rows={rowsHistory} />
        </TabPanel>
      </div>
    </div>
  )
}

export default TabMaster
